import * as React from "react"
import { SVGProps } from "react"
const ClickIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      d="M7 6c0-2.757 2.243-5 5-5s5 2.243 5 5c0 1.627-.793 3.061-2 3.974V6c0-1.654-1.346-3-3-3S9 4.346 9 6v3.974C7.793 9.061 7 7.627 7 6zm17 7a2 2 0 0 0-2 2v-1a2 2 0 0 0-4 0v-1a2 2 0 0 0-4 0V6a2 2 0 0 0-4 0v10.277A1.987 1.987 0 0 0 9 16a2 2 0 0 0-2 2v3c0 .454.155.895.438 1.249L11 28h12l2.293-3.293C25.682 24.318 26 23.55 26 23v-8a2 2 0 0 0-2-2zM11 29v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-1H11z"
      style={{
        fill: "var(--bs-emphasis-color)",
      }}
    />
  </svg>
)
export default ClickIcon
